<template>
  <div>
    <div class="dish-card-editor">
      <h2 class="c-white title">{{$t('menu_settings.addition')}}</h2>
      <div class="review-form">
        <!-- <div class="card-image position-relative">
        <img class="dish-edit-image blur" :src="dish.image ? dish.image : '/icons/no-dish.png'" />

        <ImageUploader class="upload-button" @success="onImageChange" @start="onStartImageUpload" />
        </div>-->

        <div class="dish-info-edit">
          <div class="dish-title-price">
            <input
              type="text"
              class="dish-title-edit mt-0"
              :placeholder="$t('menu_settings.name')"
              v-model="edit_modificator.name"
              id="dishNameField"
            />
            <div class="d-flex justify-content-between">
              <input
                type="number"
                class="dish-price-edit"
                :placeholder="$t('menu_settings.price')"
                v-model.number="edit_modificator.price"
                :disabled="edit_modificator.poster_product_id"
              />
              <!-- <input
              type="number"
              class="dish-price-edit"
              :placeholder="dish.unit == 'g' ? 'Вага' : `Об'єм`"
              v-model.number="dish.prices[0].weight"
              v-if="dish.prices.length == 1"
              />-->
            </div>

            <div class="poster-block" v-if="hasPosterIntegration">
              <p class="c-white title">{{$t('menu_settings.in_poster')}}:</p>
              <PosterMenuInput
                @setPrices="setPosterPrices"
                v-model="edit_modificator.poster_product_id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions-edit">
      <button
        class="round-button round-button-confirm modifcator-remove-button"
        @click="showDeleteUI"
      >{{$t('menu_settings.delete')}}</button>
      <button
        class="round-button round-button-confirm modifcator-edit-button"
        @click="emitFinish"
      >{{$t('menu_settings.done')}}</button>
    </div>

    <DangerConfirmModal
      @cancel="deleting = false"
      @confirm="doDeleteModificator"
      v-if="deleting"
    >{{$t('menu_settings.will_delete')}}</DangerConfirmModal>
  </div>
</template>

<script>
import PosterMenuInput from "@/components/integrations/PosterMenuInput.vue";

export default {
  data() {
    return {
      edit_modificator: {},
      deleting: false
    };
  },
  props: {
    modificator: Object
  },
  watch: {
    modificator() {
      this.setEditObject();
    }
  },
  methods: {
    setEditObject() {
      this.edit_modificator = Object.assign({}, this.modificator);
    },
    emitFinish() {
      this.$store.commit("menu/updateModificator", {
        from: this.modificator,
        to: this.edit_modificator
      });
      this.$store.dispatch("menu/save");
      this.$emit("finish");
    },
    setPosterPrices(prices) {
      this.edit_modificator.price = prices[0].value;
    },
    showDeleteUI() {
      this.deleting = true;
    },
    doDeleteModificator() {
      this.deleting = false;

      this.$store.commit("menu/removeGlobalModificator", this.modificator);
      this.$store.dispatch("menu/save");

      this.$emit("deleted");
    }
  },
  mounted() {
    this.setEditObject();
  },
  computed: {
    hasPosterIntegration() {
      return this.$store.getters.hasPosterIntegration;
    }
  },
  components: {
    PosterMenuInput
  }
};
</script>

<style scoped>
h2.title {
  font-size: 3vh;
  color: #ffffff;
  margin-bottom: 0;
}

p.title {
  font-size: 2.2vh;
  margin: 0;
}

.dish-card-editor {
  position: relative;
  width: 40vh;
  display: block;
  margin-right: 5.5vh;
}
.dish-info-edit {
  overflow-y: auto;
  /* height: 46.8vh; */
  height: 70vh;
  background: #1d1d1b;
  border-radius: 1.5vh;
  margin-top: 1vh;
  padding: 1.1vh 1.1vh 3vh;
}

.actions-edit {
  display: flex;
  justify-content: space-evenly;
  width: 40vh;
  bottom: 0;
  position: absolute;
}

.dish-price-edit,
.dish-title-edit,
select {
  background: #ffffff;
  border-radius: 0.8vh;
  border: 0;
  padding: 0 1.1vh;
  outline: none;
}

input {
  margin-top: 1vh;
}

select {
  height: 3.8vh;
  width: 38%;
  font-size: 2.2vh;
}

.weight-select {
  margin-left: 0.6vh;
}

.dish-desc-edit {
  width: 100%;

  background: #ffffff;
  border-radius: 0.8vh;

  font-size: 1.7vh;
  line-height: 130.8%;

  color: #464646;

  border: 0;

  margin-top: 1vh;
  outline: none;
  padding: 1vh;
}

.dish-price-edit {
  width: 100%;
  height: 4vh;
  font-weight: 500;
  font-size: 2.2vh;
  margin-top: 1vh;
  color: #000000;
}
.dish-title-edit {
  width: 100%;
  font-weight: bold;
  font-size: 2.2vh;
  height: 4vh;

  color: #000000;
}

.dish-edit-image {
  width: 100%;
  height: 21vh;
  object-fit: cover;
  border-radius: 1.5vh;
}

.w-60 {
  width: 60% !important;
}

.blur {
  filter: blur(2px);
}

.dish-variants-edit {
  margin: 2.2vh 1.1vh;
  display: grid;
}
.dish-modificators-edit {
  display: grid;
  margin: 0 1vh;
}

.dish-variants-edit h2,
.dish-modificators-edit h2,
h5 {
  font-weight: 500;
  font-size: 1.8vh;
  color: #ededed;

  margin-bottom: 0vh;
}

.dish-variants-add,
.dish-modificators-add {
  width: 100%;
  height: 3.2vh;
  margin-top: 1.2vh;
  border: 0.06vw solid #cbd9e6;
  box-sizing: border-box;
  border-radius: 0.33vw;
  font-weight: 500;
  font-size: 1.5vh;

  color: #cbd9e6;
  background: none;

  cursor: pointer;
}
.extra form {
  display: flex;
}

.extra.columns form {
  flex-flow: column nowrap;
}

.price-variant {
  width: 100%;
  height: 3.4vh;

  background: #ededed;
  border-radius: 0.5vh;
  font-weight: 500;
  font-size: 1.7vh;
  border: 0;
  outline: none;

  color: #1d1d1b;
  padding: 0.5vh;
}

.weight-size {
  width: 73% !important;
}

.price-value {
  padding: 0.5vh;

  width: 50%;
  height: 3.4vh;

  background: #ededed;
  border-radius: 0.5vh;

  font-weight: 500;
  font-size: 1.7vh;
  border: 0;
  outline: none;

  color: #1d1d1b;

  margin-left: 0.5vh;
}

.variant-delete {
  background: url("../../assets/delete.png") center #e2223b no-repeat;
  background-size: 1.6vh;
  border: 0;
  border-radius: 0.5vh;
  margin-left: 0.5vh;
  width: 18.3%;
  margin-top: 1vh;
  height: 3.4vh;
  cursor: pointer;
}

.variant-delete.small {
  width: 11.5%;
}

.variant-confirm {
  background: url("../../assets/accept.png") center #129b81 no-repeat;

  width: 2.22vw;
  height: 2.22vw;
  border: 0;
  border-radius: 1vh;
  margin-left: 0.6vh;
  background-size: 1.18vw;
  cursor: pointer;
}

.new-variant form {
  display: flex;
}

.upload-button {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: inline-block;
  margin: 0 auto;
  width: 85%;
  border: 0;
  color: #fff;
  border-radius: 0.8vw;
  font-weight: bold;
  font-size: 1vw;
  cursor: pointer;
  background-color: #464646;
}

.weighted-select {
  margin-left: 0 !important;
  margin-top: 0.5vh;
}

.card-ingredients-input {
  margin-bottom: 1vh;
}

.poster-block {
  margin-top: 2vh;
}

.dish-price-edit:disabled {
  background-color: #a4a4a4;
  color: #1d1d1b;
  cursor: not-allowed;
}

.modifcator-remove-button {
  border: 1px solid #e2223b;
  color: #e2223b;
}
</style>
